export default () => {
  const getIconComponent = (iconPath: string) => {
    // HINT: Dynamic imports can't handle files nested in folders
    // so we have to use import glob - https://vitejs.dev/guide/features#dynamic-import
    const comps = import.meta.glob('../assets/icons/**/*.svg');
    const match = comps[`../assets/icons/${iconPath}.svg`];
    if (match && typeof match === 'function') {
      return defineAsyncComponent(() => match() as any)
    }
    return null
  }

  return {
    getIconComponent,
  }
}
